import { Middleware } from '@nuxt/types'
import { createNuxtMiddleware } from '@alao-frontend/utils'

type ExternalRoute = {
  type: 'regex',
  value: RegExp,
} | {
  type: 'prefix',
  value: string,
}

// Routes list that should be using normal routing instead of virtual routing
const externalRoutes: ExternalRoute[] = [
  {
    type: 'regex',
    value: /^\/(?:(?:en|de|fr)\/)?test-page\/?/g,
  },
]

const checkRouteMatches = (route: string, { type, value }: ExternalRoute): boolean => {
  switch (type) {
    case 'regex':
      return new RegExp(value).test(route)
    case 'prefix':
      return route.startsWith(value)
    default:
      return false
  }
}

const handleExternalRoutes: Middleware = ctx => createNuxtMiddleware(ctx, ({ isServer }) => {
  const { route } = ctx

  // Server-side route matching will be handled by Traefik
  if (isServer) {
    return
  }

  if (externalRoutes.some(config => checkRouteMatches(route.path, config))) {
    window.location.replace(route.fullPath)
  }

  return false
})

export default handleExternalRoutes
